import { API_ORIGIN } from '../config'
const API_BASE = `${API_ORIGIN}/api`;

export const getUsers = (parkId) =>
  fetch(`${API_BASE}/parks/${parkId}/users`).then((r) => r.json());

export const inviteUser = async (parkId, payload) => {
  const res = await fetch(`${API_BASE}/parks/${parkId}/users/invite`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) {
    const error = new Error(data.error || 'INVITE_FAILED');
    error.status = res.status;
    error.data = data;
    throw error;
  }
  return data;
};

export const resendInvitation = (userId) =>
  fetch(`${API_BASE}/users/${userId}/resend-invite`, { method: 'POST' }).then((r) => r.json());

export const changeUserRole = async (userId, role, customRoleId, technicianId) => {
  const res = await fetch(`${API_BASE}/users/${userId}/role`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ role, customRoleId, technicianId }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'ROLE_CHANGE_FAILED');
  return data;
};

// technicianId null = desvincular.
export const linkUserTechnician = async (userId, technicianId) => {
  const res = await fetch(`${API_BASE}/users/${userId}/technician`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ technicianId }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'LINK_FAILED');
  return data;
};

export const suspendUser = (userId) =>
  fetch(`${API_BASE}/users/${userId}/suspend`, { method: 'POST' }).then((r) => r.json());

export const reactivateUser = async (userId) => {
  const res = await fetch(`${API_BASE}/users/${userId}/reactivate`, { method: 'POST' });
  const data = await res.json();
  if (!res.ok) {
    const error = new Error(data.error || 'REACTIVATE_FAILED');
    error.data = data;
    throw error;
  }
  return data;
};

export const deleteUser = (userId) =>
  fetch(`${API_BASE}/users/${userId}`, { method: 'DELETE' });

export const getCustomRole = (parkId) =>
  fetch(`${API_BASE}/parks/${parkId}/custom-role`).then((r) => r.json());

export const saveCustomRole = (parkId, payload) =>
  fetch(`${API_BASE}/parks/${parkId}/custom-role`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).then((r) => r.json());

export const getExternalAccesses = (parkId) =>
  fetch(`${API_BASE}/parks/${parkId}/external-accesses`).then((r) => r.json());

export const getAccessSettings = (parkId) =>
  fetch(`${API_BASE}/parks/${parkId}/config/access`).then((r) => r.json());

export const saveAccessSettings = async (parkId, payload) => {
  const res = await fetch(`${API_BASE}/parks/${parkId}/config/access`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || 'Error al guardar la configuración de accesos');
  }
  return res.json();
};